// Lightweight analytics helper. Fires events to GA4 (gtag), PostHog, and our backend.
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const trackEvent = (name, params = {}) => {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", name, params);
    }
  } catch (e) { /* no-op */ }
  try {
    if (typeof window !== "undefined" && window.posthog && window.posthog.capture) {
      window.posthog.capture(name, params);
    }
  } catch (e) { /* no-op */ }
  // Persist to backend for the admin analytics panel (fire-and-forget)
  try {
    const body = JSON.stringify({
      name,
      cta: params.cta || null,
      location: params.location || null,
      page: typeof window !== "undefined" ? window.location.pathname : null,
      meta: params,
    });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${API}/events`, new Blob([body], { type: "application/json" }));
    } else {
      fetch(`${API}/events`, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true });
    }
  } catch (e) { /* no-op */ }
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};
